import React from 'react';
import PropTypes from 'prop-types';

import SectionHeader from '../../shared/section-header';

import style from './index.module.scss';

function Credentials({ credentials }) {
  const userCredentials = [
    {
      text: credentials.profession,
      icon: 'fa-briefcase',
      moreText: '',
    },
    {
      text: credentials.education,
      icon: 'fa-graduation-cap',
      moreText: 'Graduated 2016',
    },
    {
      text: credentials.location,
      icon: 'fa-map-marker-alt',
      moreText: '',
    },
    {
      text: '343.2k answer views',
      icon: 'fa-eye',
      moreText: '10.2k this month',
    },
  ];

  return (
    <div className={style.credentials}>
      <SectionHeader
        headingLeft="Credentials & Highlights"
        headingRight="More"
        colWith={10}
      />
      <div className={`row ${style['row--main']}`}>
        {userCredentials.map((credential, index) => (
          <>
            {credential.text && (
              <p className={`col-12 ${style.credential}`} key={index}>
                <span className="row">
                  <span className={`col-1 ${style['credential-icon']}`}>
                    <i className={`fas ${credential.icon}`} />
                  </span>
                  <span className="col-11">
                    <span className={style['credential-text']}>
                      {credential.text}
                    </span>
                    {credential.moreText && (
                      <span
                        className={`text-muted ${style['credential-text']}`}
                      >
                        {credential.moreText}
                      </span>
                    )}
                  </span>
                </span>
              </p>
            )}
          </>
        ))}
        {credentials.isTopWriter && (
          <p className={`col-12 ${style.credential}`}>
            <span className="row">
              <span className={`col-1 ${style['credential-icon']}`}>
                <img
                  src="https://qsf.fs.quoracdn.net/-3-images.icons.top_writer_gray.svg-26-f0192737af5c7999.svg"
                  alt="Pen icon"
                  className={style['credential-img']}
                />
              </span>
              <span className="col-11">
                <span className={style['credential-text']}>Top Writer</span>
                <span className={`text-muted ${style['credential-text']}`}>
                  2018
                </span>
              </span>
            </span>
          </p>
        )}
      </div>
    </div>
  );
}

Credentials.propTypes = {
  credentials: PropTypes.shape({
    profession: PropTypes.string.isRequired,
    education: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
    isTopWriter: PropTypes.bool.isRequired,
  }).isRequired,
};

export default Credentials;
